import styled from 'styled-components';
import IconMapMarker from '../../../../common/components/icons/IconMapMarkerKeyline.svg';
import { ThemeColours } from '../../../../common/styles/ThemeColours';
import {
  FontWeight,
  FONT_STACK,
  LINK_STYLE,
  RESET_IOS_INPUT_STYLE,
  STANDARD_TRANSITION,
} from '../../../../common/styles/constants';
import { propSwitch } from '../../../../common/util/propSwitch';

export const LocationFilterBox = styled.div`
  ${FONT_STACK};
  background: white;
  color: ${ThemeColours.black};
`;

export const LocationFilterHeader = styled.div`
  margin: 8px 32px;
`;

export const FilterTextInput = styled.input`
  ${STANDARD_TRANSITION};
  ${RESET_IOS_INPUT_STYLE};
  background-color: ${ThemeColours.mono100};
  border: solid 1px ${ThemeColours.mono200};
  border-radius: 8px;
  box-sizing: border-box;
  color: ${ThemeColours.black};
  font-size: 16px;
  ${FONT_STACK}
  font-weight: ${FontWeight.SEMI_BOLD};
  height: 58px;
  padding: 0 16px;
  width: 100%;

  &::placeholder {
    color: ${ThemeColours.mono600};
  }

  &:focus {
    outline: 0;
  }
`;

export const Title = styled.h2`
  font-size: 24px;
  line-height: 32px;
  margin: 0 0 16px;
`;

export const LocationList = styled.ul`
  font-size: 16px;
  font-weight: ${FontWeight.SEMI_BOLD};
  line-height: 19px;
  margin: 16px 0 0;
  padding: 0;
`;

export const StyledMapMarker = styled(IconMapMarker)`
  height: 16px;
  margin-inline-end: 20px;
  width: 16px;
`;

export const LocationListItem = styled.li`
  background-color: ${propSwitch('aria-selected', ThemeColours.mono100, 'none')};
  list-style: none;
  padding: 16px 32px;

  &:hover {
    background-color: ${ThemeColours.mono100};
    cursor: pointer;
  }
`;

export const Error = styled.div`
  ${FONT_STACK};
  padding-inline-start: 32px;
`;

export const LoadingWrapper = styled.div`
  margin: 0 32px;
`;

export const Link = styled.span`
  ${FONT_STACK};
  ${LINK_STYLE};
`;
